import React from 'react';

interface AircraftStatusPillProps {
  status: string | null | undefined;
  size?: 'small' | 'medium' | 'large';
}

const getStatusColor = (status: string) => {
  switch (status) {
    case 'STANDBY':
      return { color: '#1B5E20', bg: '#E8F5E9' }; // Green
    case 'MISSION':
      return { color: '#0D47A1', bg: '#E3F2FD' }; // Blue
    case 'ABORT':
      return { color: '#B71C1C', bg: '#FFEBEE' }; // Red
    case 'MAINTENANCE':
      return { color: '#F57F17', bg: '#FFF8E1' }; // Amber
    case 'MOTORSTEST':
      return { color: '#E65100', bg: '#FFF3E0' }; // Orange
    default:
      return { color: 'inherit', bg: 'transparent' };
  }
};

export const AircraftStatusPill = ({ status, size = 'small' }: AircraftStatusPillProps) => {
  if (!status) return null;
  const statusColors = getStatusColor(status);

  const sizeStyles = {
    small: {
      padding: '2px 8px',
      fontSize: '0.70rem',
    },
    medium: {
      padding: '4px 12px',
      fontSize: '0.85rem',
    },
    large: {
      padding: '6px 16px',
      fontSize: '1.4rem',
    }
  };

  return (
    <span style={{
      backgroundColor: statusColors.bg,
      color: statusColors.color,
      borderRadius: '12px',
      fontWeight: 500,
      display: 'inline-block',
      ...sizeStyles[size]
    }}>
      {status}
    </span>
  );
}; 